"use strict";

import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PersonalDetailsForm from './PersonalDetailsForm';

import { AccountActions, SessionActions, AlertActions } from '../../../actions';

class SignUp extends Component{
  constructor() {
    super();
    this.state = {
      canSubmit: false,
      agreeToPolicy : false
    };

    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleInputChange = this._handleInputChange.bind(this);
    this._onFormValid = this._onFormValid.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired
  };

  render() {
    return(
      <Modal show={this.props.open} onHide={SignUp._handleCloseSignUpPopup}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Sign Up</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PersonalDetailsForm ref="form" isValid={this._onFormValid} />
          <p>
            <div className="checkbox">
              <label style={{fontWeight:'normal'}}><input type="checkbox" value={this.state.agreeToPolicy} onChange={this._handleInputChange.bind(this, 'agreeToPolicy')}/> I agree to the <a href="https://mentorstudents.org/terms-and-conditions" target="_blank">Terms of Use</a> and <a href="https://mentorstudents.org/privacy-policy" target="_blank">Privacy Policy</a></label>
            </div>
          </p>
          <div>
          <Button bsStyle="success" disabled={(!this.state.canSubmit) || (!this.state.agreeToPolicy)} onClick={this._handleSubmit} >Sign Up</Button>
          <Button className="m-l-5p" type="submit" bsStyle="default" onClick={SignUp._handleCloseSignUpPopup}>Cancel</Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-center">
          <span>Already have account? </span>
          <a style={{cursor: 'pointer'}} onClick={ SignUp._handleSignInPopup }>Sign In</a>
        </div>
        </Modal.Footer>
      </Modal>
    )
  };

  static _handleCloseSignUpPopup() {
    AccountActions.closeSignUpPopup();
  };

  _handleSubmit(e) {
    e.preventDefault();
    let user = this.refs.form.getModel();
    // console.log("signup file00-0===========",user);
    AccountActions.register(user, function (error) {
      if (error) return AlertActions.error({ message: error.message });

      AccountActions.closeSignUpPopup();
    });
  };

  _onFormValid(isValid) {
    this.setState({ canSubmit: isValid });
  };
  _handleInputChange(formInput, event) {
    let value = !this.state.agreeToPolicy;
    this.setState(state => {
      state['agreeToPolicy'] = value;
    }, () => {
    });
  };
  static _handleSignInPopup() {
    AccountActions.closeSignUpPopup();
    SessionActions.openSignInPopup();
  };
}

export default SignUp;
